import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      img {\n        border-radius: 0.75rem;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { css } from "@emotion/react";
var ImageWrapper = /*#__PURE__*/ styled("div", {
    target: "evp21wl0"
})(function(param) {
    var roundedBorder = param.roundedBorder;
    return roundedBorder && css(_templateObject());
}, ";");
export { ImageWrapper };
